import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, CheckCheck, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { ClientShell, useClientUser } from "@/pages/client/ClientShell";

export default function ClientNotifications() {
  const user = useClientUser();
  const [data, setData] = useState(null);
  useEffect(() => { if (user) api.get("/client/notifications").then((r) => setData(r.data)).catch(() => setData({ unread: 0, items: [] })); }, [user]);
  if (!user) return null;

  const markAll = async () => { await api.post("/client/notifications/read-all").catch(() => {}); setData((d) => ({ unread: 0, items: d.items.map((n) => ({ ...n, read: true })) })); };

  return (
    <ClientShell user={user} title="Notifications">
      <div className="mt-2 flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-slate-500">Order updates and desk messages{data ? ` · ${data.unread} unread` : ""}.</p>
        {data?.unread > 0 && <button data-testid="notifications-read-all" onClick={markAll} className="flex items-center gap-1.5 border border-slate-200 px-3 py-2 font-mono2 text-[10px] uppercase tracking-[0.18em] text-slate-600 hover:text-[#6D28D9]"><CheckCheck className="h-3.5 w-3.5" /> Mark all read</button>}
      </div>
      {!data && <p className="mt-8 font-mono2 text-xs uppercase tracking-[0.25em] text-slate-500">Loading…</p>}
      {data?.items.length === 0 && <div data-testid="notifications-empty" className="mt-8 flex flex-col items-center border border-dashed border-slate-300 bg-[#F6F4FD]/60 px-6 py-14 text-center"><Bell className="h-6 w-6 text-[#6D28D9]" /><p className="font-display mt-4 text-lg font-semibold">You're all caught up</p><p className="mt-1 text-sm text-slate-500">Order and payment updates will appear here.</p></div>}
      <ul data-testid="notifications-list" className="mt-6 space-y-px border border-slate-200 bg-slate-200 empty:border-0">
        {data?.items.map((n) => (
          <li key={n.id} data-testid={`notification-${n.id}`} className={`flex items-start justify-between gap-4 px-5 py-4 ${n.read ? "bg-white" : "bg-[#F6F4FD]"}`}>
            <div className="min-w-0">
              <p className={`text-sm ${n.read ? "text-slate-700" : "font-semibold text-slate-900"}`}>{n.title}</p>
              <p className="mt-0.5 text-sm text-slate-500">{n.body}</p>
              <p className="mt-1 font-mono2 text-[10px] uppercase tracking-[0.12em] text-slate-400">{new Date(n.created_at).toLocaleString("en-IN")}</p>
            </div>
            {n.link && <Link to={n.link} className="shrink-0 text-slate-400 hover:text-[#6D28D9]"><ArrowRight className="h-4 w-4" /></Link>}
          </li>
        ))}
      </ul>
    </ClientShell>
  );
}
